<template>
    <div class="search-input" :class="{ 'is-active': !!searchString }">
        <input
            v-model="searchString"
            :autofocus="autofocus"
            type="text"
            :placeholder="placeholder"
            class="search-input__input"
            @keyup="onSearchInput"
            @keydown.enter.prevent="onSearchInput"
        />
        <button
            v-if="!!searchString"
            class="button button--blank search-input__clear"
            type="button"
            @click="clear"
        >
            ✕
        </button>
    </div>
</template>

<script>
export default {
    name: 'SearchInput',
    emits: ['change'],
    props: {
        debounce: {
            type: Number,
            default: 250
        },
        placeholder: {
            type: String,
            default: ''
        },
        autofocus: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchString: '',
            searchInputTimeout: null
        };
    },
    beforeUnmount() {
        clearTimeout(this.searchInputTimeout);
        this.searchInputTimeout = null;
    },
    methods: {
        onSearchInput() {
            clearTimeout(this.searchInputTimeout);

            this.searchInputTimeout = setTimeout(() => {
                this.$emit('change', this.searchString);
            }, this.debounce);
        },
        setSearchString(str) {
            this.searchString = str;
        },
        clear() {
            this.searchString = '';
            this.$emit('change', this.searchString);
        }
    }
};
</script>

<style lang="scss" src="./SearchInput.scss"></style>
